import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { RenderKilogramo, RenderNumber } from "../../../../../../Utils/renderField/renderReadField";
import { ESTADOS_PALETIZACION } from "../../../../../../../../utility/constants";
import Badge from "../../../../../../Utils/Badge/Badge";
const verIcon = require("assets/img/icons/ver.png");

export const IngresosTable = ({ paletizaciones, estado, estadoMultiple }) => {
    const getBannerEstado = (itemEstado) => {
        if (itemEstado === ESTADOS_PALETIZACION.ACEPTADO_PARCIAL) {
            return <Badge text="Aceptado parcial" variant="warning" />;
        } else if (itemEstado === ESTADOS_PALETIZACION.ACEPTADO) {
            return <Badge text="Aceptado" variant="success" />;
        } else {
            return null;
        }
    };

    return (
        <div className="new-table-wrapper ingresos-bodega__table-wrapper">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th>Fecha - hora</th>
                        <th>Cant. pallets</th>
                        <th>Cant. pacas</th>
                        <th>Pacas turno actual</th>
                        <th>Pacas turno anterior</th>
                        <th>Pacas en reclasificación</th>
                        {estadoMultiple && <th>Estado</th>}
                        <th>Kg hule seco</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {paletizaciones.length === 0 && (
                        <tr>
                            <td
                                colSpan={estadoMultiple ? 9 : 8}
                                className="text-center"
                            >
                                No hay registros de paletización enviados a
                                bodega
                            </td>
                        </tr>
                    )}
                    {paletizaciones.map((item) => {
                        return (
                            <tr key={item.id}>
                                <td className="text-center text-nowrap">
                                    {item.fecha_con_desfase
                                        ? moment(item.fecha_con_desfase).format(
                                              "DD/MM/YYYY - HH:mm",
                                          )
                                        : "N/A"}
                                </td>
                                <td className="text-center">
                                    <RenderNumber value={item.total_pallets} />
                                </td>
                                <td className="text-center">
                                    <RenderNumber value={item.total_pacas} />
                                </td>
                                <td className="text-center">
                                    <RenderNumber value={item.total_pacas_turno_actual} />
                                </td>
                                <td className="text-center">
                                    <RenderNumber value={item.total_pacas_turno_anterior} />
                                </td>
                                <td className="text-center">
                                    <RenderNumber
                                        value={item.total_pacas_reclasificacion} />
                                </td>
                                {estadoMultiple && (
                                    <td className="text-center">
                                        {getBannerEstado(item.estado)}
                                    </td>
                                )}
                                <td className="text-center text-nowrap">
                                    <RenderKilogramo
                                        value={item.total_peso}
                                        decimals={2}
                                    />
                                </td>

                                <td>
                                    <div className="table-actions">
                                        <Link
                                            to={
                                                estado ===
                                                ESTADOS_PALETIZACION.PENDIENTE
                                                    ? `/produccion-bodega/recepcion-ingreso/${item.id}`
                                                    : `/produccion-bodega/detalle-recepcion/${item.id}`
                                            }
                                        >
                                            <img
                                                src={verIcon}
                                                alt="Ver"
                                                className="action_img"
                                                title="Ver"
                                            />
                                        </Link>
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
